import React, { useEffect, useState, useRef } from 'react';
import '../../Automations.css';

/**
 * props:
 * - selectedIndex
 * - indexes
 * - onAddClick
 * - variant: 'inline' | 'stacked'
 */
function VariableInput(props) {
    const variant = props.variant || 'inline';

    const variableRef = useRef('');
    const [index, setIndex] = useState({});
    const [operator, setOperator] = useState('>');
    const [variable, setVariable] = useState('');
    useEffect(() => {
        setIndex(props.selectedIndex);
        setVariable(props.selectedIndex.example);
        variableRef.current.value = '';
    }, [props.selectedIndex])

    function getOptionText(symbol, variable) {
        if (!variable) return '';
        return variable.startsWith('WALLET_') ? `${symbol}:${variable}` : variable;
    }

    function formatOperatorForDisplay(op) {
        if (op === '==') return '=';
        return op;
    }

    function getExpressionText() {
        const value = typeof index.example === 'string' ? '${variable}' : variable;
        return `${index.symbol}:${index.variable} ${formatOperatorForDisplay(operator)} ${value}`;
    }

    function onAddClick(event) {
        const value = typeof index.example === 'string' ? '${variable}' : variable;
        const condition = {
            eval: `${index.eval}${operator}${value}`,
            text: getExpressionText()
        }
        props.onAddClick({ target: { id: 'condition', value: condition } });

        setOperator('>');
        variableRef.current.value = '';
    }

    function onOperatorChange(event) {
        setOperator(event.target.value);
    }

    function onVariableChange(event) {
        const value = event.target.value;
        const index = props.indexes.find(k => value.endsWith(k.variable));
        if (index && value.indexOf('WALLET_') === -1)
            setVariable(index.eval);
        else
            setVariable(value);
    }

    const operatorSelect = (
        <select id="operator" className="form-select" onChange={onOperatorChange} value={operator}>
            <option value="==">equals</option>
            <option value=">">greater than</option>
            <option value=">=">greater or equals</option>
            <option value="<">less than</option>
            <option value="<=">less or equals</option>
        </select>
    );

    const valueInput = (
        <input
            ref={variableRef}
            id="variable"
            list="variables"
            type="text"
            className="form-control"
            onChange={onVariableChange}
            placeholder={`${index.example}`}
        />
    );

    const addButton = (
        <button
            type="button"
            className="btn btn-primary btn-sm conditions-add-btn"
            onClick={onAddClick}
            title="Add condition"
        >
            <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
            </svg>
        </button>
    );

    if (variant === 'stacked') {
        return (
            <div className="conditions-variable--stacked">
                <div className="private-page-field">
                    <label htmlFor="operator" className="private-page-label">Operator</label>
                    {operatorSelect}
                </div>
                <div className="private-page-field">
                    <label htmlFor="variable" className="private-page-label">Value</label>
                    <div className="conditions-value-row">
                        {valueInput}
                        {addButton}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="input-group input-group-merge mb-2">
            <span className="input-group-text bg-secondary">
                is
            </span>
            {operatorSelect}
            {valueInput}
            {addButton}
        </div>
    )
}

export default VariableInput;